import React from "react";
import ReactDOM from "react-dom/client";
import "flowbite/dist/flowbite.css";
import "./index.css";
import App from "./App";

const rootElement = document.getElementById("root");
rootElement.className = "bg-cream";
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
